var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useRef } from 'react';
import { LAMPORTS_PER_SOL } from '@solana/web3.js';
import { Button, Popover, Tooltip } from 'antd';
import Jazzicon from 'jazzicon';
import { CopyOutlined } from '@ant-design/icons';
import bs58 from 'bs58';
import { useWallet } from '../../contexts/WalletContext';
import { useSolPrice } from '../../contexts/coingecko';
import { useNativeAccount } from '../../contexts/accounts';
import { formatNumber, formatUSD, shortenAddress } from '../../utils/common';
export var Identicon = function (props) {
    var _a;
    var style = props.style, className = props.className, alt = props.alt;
    var address = typeof props.address === 'string'
        ? props.address
        : (_a = props.address) === null || _a === void 0 ? void 0 : _a.toBase58();
    var ref = useRef();
    useEffect(function () {
        if (address && ref.current) {
            try {
                ref.current.innerHTML = '';
                ref.current.className = className || '';
                // Convert Uint8Array to hex string for Jazzicon seed
                var decoded = bs58.decode(address);
                var hexString = Array.from(decoded)
                    .map(function (b) { return b.toString(16).padStart(2, '0'); })
                    .join('');
                ref.current.appendChild(Jazzicon((style === null || style === void 0 ? void 0 : style.width) || 16, parseInt(hexString.slice(5, 15), 16)));
            }
            catch (err) {
                // TODO
            }
        }
    }, [address, style, className]);
    return (_jsx("div", { className: "identicon-wrapper", title: alt, ref: ref, style: props.style }));
};
export var Settings = function (_a) {
    var additionalSettings = _a.additionalSettings;
    var publicKey = useWallet().publicKey;
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ style: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                paddingTop: '15px',
            } }, { children: [_jsx(Identicon, { address: publicKey === null || publicKey === void 0 ? void 0 : publicKey.toBase58(), style: {
                        width: 48,
                    } }), publicKey && (_jsx(_Fragment, { children: _jsx(Tooltip, __assign({ title: "Copy address" }, { children: _jsxs("div", __assign({ style: {
                                fontWeight: 600,
                                letterSpacing: '-0.02em',
                                color: '#FFFFFF',
                            }, onClick: function () {
                                return navigator.clipboard.writeText((publicKey === null || publicKey === void 0 ? void 0 : publicKey.toBase58()) || '');
                            } }, { children: [_jsx(CopyOutlined, {}), "\u00A0", shortenAddress(publicKey === null || publicKey === void 0 ? void 0 : publicKey.toBase58())] })) })) })), _jsx("br", {}), _jsx("span", { style: {
                        borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                        width: 'calc(100% + 32px)',
                        marginTop: 10,
                        marginBottom: 10,
                    } }), additionalSettings] })) }));
};
var btnStyle = {
    border: 'none',
    height: 40,
};
export var CurrentUserBadge = function (props) {
    var _a = useWallet(), wallet = _a.wallet, publicKey = _a.publicKey, disconnect = _a.disconnect;
    var account = useNativeAccount().account;
    var solPrice = useSolPrice();
    if (!wallet || !publicKey) {
        return null;
    }
    var balance = ((account === null || account === void 0 ? void 0 : account.lamports) || 0) / LAMPORTS_PER_SOL;
    var balanceInUSD = balance * solPrice;
    var iconStyle = {
        display: 'flex',
        width: props.iconSize,
        borderRadius: 50,
    };
    var name = props.showAddress ? shortenAddress("".concat(publicKey)) : '';
    var unknownWallet = wallet;
    if (unknownWallet.name && !props.showAddress) {
        name = unknownWallet.name;
    }
    var image = _jsx(Identicon, { address: publicKey === null || publicKey === void 0 ? void 0 : publicKey.toBase58(), style: iconStyle });
    if (unknownWallet.image) {
        image = _jsx("img", { src: unknownWallet.image, style: iconStyle });
    }
    return (_jsxs("div", __assign({ className: "wallet-wrapper" }, { children: [props.showBalance && (_jsxs("span", { children: [formatNumber.format(((account === null || account === void 0 ? void 0 : account.lamports) || 0) / LAMPORTS_PER_SOL), " SOL"] })), _jsx(Popover, __assign({ trigger: "click", placement: "bottomRight", content: _jsx(Settings, { additionalSettings: _jsxs("div", __assign({ style: {
                            width: 250,
                            paddingLeft: '10px',
                        } }, { children: [_jsx("h5", __assign({ style: {
                                    color: 'rgba(255, 255, 255, 0.7)',
                                    letterSpacing: '0.02em',
                                } }, { children: "BALANCE" })), _jsxs("div", __assign({ style: {
                                    marginBottom: 10,
                                } }, { children: [_jsxs("span", __assign({ style: {
                                            fontWeight: 600,
                                            color: '#FFFFFF',
                                        } }, { children: [formatNumber.format(balance), " SOL"] })), "\u00A0", _jsx("span", __assign({ style: {
                                            color: 'rgba(255, 255, 255, 0.5)',
                                        } }, { children: formatUSD.format(balanceInUSD) })), "\u00A0"] })), _jsx("div", __assign({ style: {
                                    display: 'flex',
                                    marginBottom: 10,
                                } }, { children: _jsx(Button, __assign({ className: "metaplex-button-default", onClick: disconnect, style: __assign(__assign({}, btnStyle), { paddingLeft: 0 }) }, { children: "Disconnect" })) }))] })) }) }, { children: _jsxs(Button, __assign({ className: "wallet-key" }, { children: [image, name && (_jsx("span", __assign({ style: {
                                marginLeft: '0.5rem',
                                fontWeight: 600,
                            } }, { children: name })))] })) }))] })));
};
export var CurrentUserBadgeMobile = function (props) {
    var _a = useWallet(), wallet = _a.wallet, publicKey = _a.publicKey, disconnect = _a.disconnect;
    var account = useNativeAccount().account;
    var solPrice = useSolPrice();
    if (!wallet || !publicKey) {
        return null;
    }
    var balance = ((account === null || account === void 0 ? void 0 : account.lamports) || 0) / LAMPORTS_PER_SOL;
    var balanceInUSD = balance * solPrice;
    var iconStyle = {
        display: 'flex',
        width: props.iconSize,
        borderRadius: 50,
    };
    var name = props.showAddress ? shortenAddress("".concat(publicKey)) : '';
    var unknownWallet = wallet;
    if (unknownWallet.name && !props.showAddress) {
        name = unknownWallet.name;
    }
    var image = _jsx(Identicon, { address: publicKey === null || publicKey === void 0 ? void 0 : publicKey.toBase58(), style: iconStyle });
    if (unknownWallet.image) {
        image = _jsx("img", { src: unknownWallet.image, style: iconStyle });
    }
    return (_jsxs("div", __assign({ className: "current-user-mobile-badge" }, { children: [_jsxs("div", __assign({ className: "mobile-badge" }, { children: [image, name && (_jsx("span", __assign({ style: {
                            marginLeft: '0.5rem',
                            fontWeight: 600,
                        } }, { children: name })))] })), _jsxs("div", __assign({ className: "balance-container" }, { children: [_jsx("span", __assign({ className: "balance-title" }, { children: "Balance" })), _jsxs("span", { children: [formatNumber.format(balance), "\u00A0\u00A0 SOL", ' ', _jsx("span", __assign({ style: {
                                    marginLeft: 5,
                                    fontWeight: 'normal',
                                    color: 'rgba(255, 255, 255, 0.5)',
                                } }, { children: formatUSD.format(balanceInUSD) }))] })] })), _jsx("div", __assign({ className: "actions-buttons" }, { children: _jsx(Button, __assign({ className: "black-btn", onClick: disconnect }, { children: "Disconnect" })) }))] })));
};
